export const ActionTypes = {
  LOADING: "LIST_SAMPLE_LOADING",
  ERROR: "LIST_SAMPLE_LOADING_ERROR",
  SUCCESS: "LIST_SAMPLE_LOADING_SUCCESS",
  DELETE_DECISION: "LIST_SAMPLE_DELETE_DECISION",
};
